import { FormHandler } from "@raiden/library/components/ReactHookForm/FormHandler";
import generateApiUri from "@raiden/library/libraries/utils/generateApiUri";

/**
 * @typedef {object} CafFormValues
 * @property {string} caf_number
 * @property {string} pending_caf_coeff
 * @property {string} pending_dependent_children_count
 * @property {boolean} _has_children
 * @property {string} pending_reference_tax_income
 *
 * @param {object} params
 * @param {import("@raiden/library/types/Customer").Customer} params.item
 *
 * @returns {CafFormValues}
 */
function getDefaultValues({ item }) {
  const pending_dependent_children_count =
    (item.pending_dependent_children_count ?? "") !== ""
      ? String(item.pending_dependent_children_count)
      : (item.dependent_children_count ?? "") !== ""
      ? String(item.dependent_children_count)
      : "";
  const caf_number = item.caf_number ? String(item.caf_number) : "";
  const pending_caf_coeff =
    (item.pending_caf_coeff ?? "") !== ""
      ? String(item.pending_caf_coeff)
      : (item.caf_coeff ?? "") !== ""
      ? String(item.caf_coeff)
      : "";
  const pending_reference_tax_income =
    (item.pending_reference_tax_income ?? "") !== ""
      ? String(item.pending_reference_tax_income)
      : (item.reference_tax_income ?? "") !== ""
      ? String(item.reference_tax_income)
      : "";
  return {
    _has_children:
      Boolean(pending_dependent_children_count) ||
      Boolean(caf_number) ||
      Boolean(pending_caf_coeff) ||
      Boolean(pending_reference_tax_income), // le champ s'affichera si l'un des champs est rempli
    caf_number,
    pending_caf_coeff,
    pending_dependent_children_count,

    pending_reference_tax_income,
  };
}

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Customer").Customer} customer
 * @property {(params: { response: import("@raiden/library/types/Api/ApiResponse").ApiResponse<any>, form: import("react-hook-form").UseFormReturn<any>}) => void} [onSuccess]
 * @property {boolean} [showSuccessToast]
 * @property {(props: { isLoading: boolean }) => import("react").ReactElement} render
 *
 * @param {Props} props
 */
function CustomerCafUpdateHandler({
  customer,
  onSuccess,
  showSuccessToast = true,
  render,
}) {
  return (
    <FormHandler
      defaultValues={getDefaultValues({ item: customer })}
      getRequestParams={({ values }) => ({
        url: generateApiUri({
          id: "@customers.update",
          parameters: {
            customerId: customer.id,
          },
        }),
        init: {
          method: "POST",
          body: {
            data: {
              ...values,
              _has_children: undefined,
              ...(!values?._has_children && {
                pending_dependent_children_count: null,
                pending_caf_coeff: null,
                pending_reference_tax_income: null,
                caf_number: null,
              }),
            },
          },
        },
      })}
      showSuccessToast={showSuccessToast}
      onSuccess={({ form, response }) => {
        form.reset(getDefaultValues({ item: response.data }));
        onSuccess?.({ form, response });
      }}
      children={({ isLoading }) => render({ isLoading })}
    />
  );
}

export default CustomerCafUpdateHandler;
